<script>
import { mapState } from "vuex";

import { validateAndSubmit } from "../../../mixins/validateAndSubmit";
import { validationClass } from "../../../mixins/validationClass";

export default {
  data() {
    return {
      form: {
        name: "",
        area: "",
        current_situation: "",
        envisaged_future: "",
        difficulty: "",
        urgency: "",
        importance: "",
        level_of_need: "",
        duration: "",
        cost: "",
        value: "",
        control: "",
        realistic_because: "",
        achievable_because: "",
        achieved_because: "",
        start_date: null,
        end_date: null,
        completion_date: null,
        relevant_to_purpose: false,
        relevant_to_vision: false,
        relevant_to_values: false,
        steps: [""],
      },
      addNew: false,
      section: 1,
      disableOnSubmit: false,
      dictionary: {
        en: {
          attributes: {
            name: "Name",
            area: "Area",
            start_date: "Start Date",
            end_date: "Deadline Date",
            current_situation: "Current situation",
            required_situation: "Required Situation",
            envisaged_future: "Envisaged Future",
            realistic_because: "I know this is Realistic because",
            achievable_because: "I know this is achievable because",
            achieved_because:
              "I know I will have achieved this goal when/because",
          },
        },
      },
      relevant_to_none: false,
    };
  },

  props: [
    "url",
    "isActive",
    "start",
    "activeGoals",
    "isEdit",
    "completion",
    "getUrl",
  ],

  mixins: [validateAndSubmit, validationClass],

  computed: {
    relevant_to_purpose: function () {
      return this.form.relevant_to_purpose;
    },
    relevant_to_vision: function () {
      return this.form.relevant_to_vision;
    },
    relevant_to_values: function () {
      return this.form.relevant_to_values;
    },
    date_from_formatted: function () {
      return this.formatDate(this.form.start_date);
    },
    date_to_formatted: function () {
      return this.formatDate(this.form.end_date);
    },
    date_completed_formatted: function () {
      return this.formatDate(this.form.completion_date);
    },
  },

  created() {},

  mounted() {
    if (this.isEdit == "true") {
      this.getGoal();
    }

    this.$validator.localize(this.dictionary);

    setTimeout(function () {
      $('[data-toggle="tooltip"]').tooltip();
    }, 500);

    if (this.completion) {
      this.section = 4;
    }
  },

  watch: {
    relevant_to_none: function (newVal) {
      if (newVal) {
        this.setRelevantFieldsToFalse();
      }
    },
    relevant_to_purpose: function (newVal) {
      if (newVal) {
        this.relevant_to_none = false;
      }
    },
    relevant_to_vision: function (newVal) {
      if (newVal) {
        this.relevant_to_none = false;
      }
    },
    relevant_to_values: function (newVal) {
      if (newVal) {
        this.relevant_to_none = false;
      }
    },
  },

  methods: {
    getGoal() {
      axios
        .get(this.getUrl)
        .then((response) => {
          this.form = response.data.data;

          if (isNaN(this.form.value)) {
            this.form.value = null;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addStep() {
      if (this.form.steps === null) {
        this.form.steps = [];
      }
      this.form.steps.push("");
    },

    removeStep(index) {
      if (index > -1) {
        this.form.steps.splice(index, 1);
      }
    },

    moveUp(index) {
      if (index <= 0) {
        return;
      }

      var moveDown = this.form.steps[index - 1];
      var moveUp = this.form.steps[index];

      this.form.steps[index - 1] = moveUp;
      this.form.steps[index] = moveDown;
      this.$forceUpdate();
    },

    moveDown(index) {
      if (index >= this.form.steps.length) {
        return;
      }
      var moveDown = this.form.steps[index];
      var moveUp = this.form.steps[index + 1];

      this.form.steps[index] = moveUp;
      this.form.steps[index + 1] = moveDown;
      this.$forceUpdate();
    },

    checkActiveGoals(addNew) {
      if (this.isEdit == "true") {
        this.validateAndSubmit("goals-create-edit-form");
        return;
      }

      this.addNew = addNew;
      if (this.activeGoals >= 3 && this.form.start_date == this.start) {
        $("#activeGoalsModal").modal("show");
      } else {
        this.validateAndSubmit("goals-create-edit-form");
      }
    },

    setRelevantFieldsToFalse() {
      this.form.relevant_to_purpose = false;
      this.form.relevant_to_vision = false;
      this.form.relevant_to_values = false;
    },

    formatDate(date) {
      if (!date) {
        return date;
      }
      var split = date.split("/");
      date = split[2] + "-" + split[1] + "-" + split[0];
      return date;
    },
  },
};
</script>
